import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Mint from 'mint-ui';
import tools from './js/index.js';
import './js/com.js'; // 网址配置
import './js/rem.js'; // rem

// import './js/chat.js'; // chat
// swiper 插件
import VueAwesomeSwiper from 'vue-awesome-swiper';
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

import 'mint-ui/lib/style.css';
import './css/reset.css';
import './css/loaders.css';
import './css/base.css';
import './css/icon/iconfont.css'
import 'swiper/dist/css/swiper.css'
import Region from 'v-region'
Vue.use(Region)
Vue.use(VueAwesomeSwiper, /* { default global options } */);

Vue.use(Mint);

Vue.config.productionTip = false;

Vue.prototype._tools = tools;
Vue.prototype.mywindow = window;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
